import {FeatureConfig} from '@/config/featureToggles'
import {Link} from 'pepsico-ds'

export const HowtoRequestAccess = () => {
  const accessPortalUrl = import.meta.env[FeatureConfig.accessPortalUrl]
  return (
    <div data-testid="how-to-request-access">
      <ol>
        <li>
          Go to <Link href={accessPortalUrl} label="Access Portal" target="_blank" />.
        </li>
        <li>
          Click <b>Apps Catalogue</b>, and search <b>Customer Communication Tool</b>.
        </li>
        <li>
          Click <b>Request Access.</b>
        </li>
        <li>
          Select <b>Role</b> as Admin or Member. If you select Member, you need to select the necessary Sectors and
          Markets. Admin has access to all Sectors and Markets by default.
        </li>
        <li>
          Click <b>Submit Request</b> button.
        </li>
        <li>
          Once your request is approved, you will be able to access the Customer Communication Tool application with
          Markets.
        </li>
      </ol>
    </div>
  )
}
